import React from 'react';
import { TbInfoCircle } from 'react-icons/tb';

import { Alert, Text } from '@mantine/core';

export const NoExactMatchesAlert = ({ query }: { query: string }) => (
    <Alert color="blue" variant="light" p="sm" icon={<TbInfoCircle size={16} />}>
        <Text fw={600} fz="sm">
            No exact matches for "{query}"
        </Text>
        <Text fz="sm">Showing the closest matches instead.</Text>
    </Alert>
);
